import { useState } from "react";
import {
  getEmptyRecipeFormState,
  getEmptyEditRecipeFormState,
  getEditRecipeFormState
} from "../utils/recipeHelpers";

export function useRecipeForm() {
  const [editingRecipeName, setEditingRecipeName] = useState(null);

  const [newRecipeName, setNewRecipeName] = useState("");
  const [newRecipeImage, setNewRecipeImage] = useState("");
  const [newRecipeDescription, setNewRecipeDescription] = useState("");
  const [newRecipeTime, setNewRecipeTime] = useState("");
  const [newRecipeCalories, setNewRecipeCalories] = useState("");
  const [newRecipeServings, setNewRecipeServings] = useState("");
  const [newRecipeIngredients, setNewRecipeIngredients] = useState([]);
  const [newRecipeCategory, setNewRecipeCategory] = useState("");
  const [newRecipeTag, setNewRecipeTag] = useState("");
  const [newRecipeProtein, setNewRecipeProtein] = useState("");
  const [newRecipeCarbs, setNewRecipeCarbs] = useState("");
  const [newRecipeFats, setNewRecipeFats] = useState("");
  const [newRecipeInstructions, setNewRecipeInstructions] = useState("");

  const [editRecipeName, setEditRecipeName] = useState("");
  const [editRecipeImage, setEditRecipeImage] = useState("");
  const [editRecipeDescription, setEditRecipeDescription] = useState("");
  const [editRecipeTime, setEditRecipeTime] = useState("");
  const [editRecipeCalories, setEditRecipeCalories] = useState("");
  const [editRecipeServings, setEditRecipeServings] = useState("");
  const [editRecipeIngredients, setEditRecipeIngredients] = useState([]);
  const [editRecipeCategory, setEditRecipeCategory] = useState("");
  const [editRecipeTag, setEditRecipeTag] = useState("");
  const [editRecipeProtein, setEditRecipeProtein] = useState("");
  const [editRecipeCarbs, setEditRecipeCarbs] = useState("");
  const [editRecipeFats, setEditRecipeFats] = useState("");
  const [editRecipeInstructions, setEditRecipeInstructions] = useState("");


  const [addRecipeWarning, setAddRecipeWarning] = useState("");
  const [hasTriedToSaveAddRecipe, setHasTriedToSaveAddRecipe] = useState(false);

  const [editRecipeWarning, setEditRecipeWarning] = useState("");
  const [hasTriedToSaveEditRecipe, setHasTriedToSaveEditRecipe] = useState(false);

  const [activeNewRecipeSections, setActiveNewRecipeSections] = useState([]);
  const [activeEditRecipeSections, setActiveEditRecipeSections] = useState([]);


  function clearAddRecipeForm() {
    const emptyForm = getEmptyRecipeFormState();

    setNewRecipeName(emptyForm.name);
    setNewRecipeImage("");
    setNewRecipeDescription(emptyForm.description);
    setNewRecipeTime(emptyForm.time);
    setNewRecipeCalories(emptyForm.calories);
    setNewRecipeServings(emptyForm.servings);
    setNewRecipeIngredients(emptyForm.ingredients);
    setNewRecipeCategory(emptyForm.category);
    setNewRecipeTag(emptyForm.tag);
    setNewRecipeProtein(emptyForm.protein);
    setNewRecipeCarbs(emptyForm.carbs);
    setNewRecipeFats(emptyForm.fats);
    setNewRecipeInstructions("");
    setAddRecipeWarning(emptyForm.warning);
    setHasTriedToSaveAddRecipe(emptyForm.hasTriedToSave);
    setActiveNewRecipeSections([]);
  }

  function cancelEditingRecipe() {
    const emptyForm = getEmptyEditRecipeFormState();

    setEditingRecipeName(emptyForm.editingRecipeName);
    setEditRecipeName(emptyForm.name);
    setEditRecipeImage("");
    setEditRecipeDescription(emptyForm.description);
    setEditRecipeTime(emptyForm.time);
    setEditRecipeCalories(emptyForm.calories);
    setEditRecipeServings(emptyForm.servings);
    setEditRecipeIngredients(emptyForm.ingredients);
    setEditRecipeCategory(emptyForm.category);
    setEditRecipeTag(emptyForm.tag);
    setEditRecipeProtein(emptyForm.protein);
    setEditRecipeCarbs(emptyForm.carbs);
    setEditRecipeFats(emptyForm.fats);
    setEditRecipeInstructions("");
    setEditRecipeWarning(emptyForm.warning);
    setHasTriedToSaveEditRecipe(emptyForm.hasTriedToSave);
    setActiveEditRecipeSections([]);
  }

  function startEditingRecipe(recipe) {
    const formState = getEditRecipeFormState(recipe);

    setEditRecipeWarning(formState.warning);
    setHasTriedToSaveEditRecipe(formState.hasTriedToSave);
    setEditingRecipeName(formState.editingRecipeName);
    setEditRecipeImage(recipe.image || "");
    setEditRecipeName(formState.name);
    setEditRecipeDescription(formState.description);
    setEditRecipeTime(formState.time);
    setEditRecipeCalories(formState.calories);
    setEditRecipeServings(formState.servings);
    setEditRecipeIngredients(formState.ingredients);
    setEditRecipeCategory(formState.category);
    setEditRecipeTag(formState.tag);
    setEditRecipeProtein(formState.protein);
    setEditRecipeCarbs(formState.carbs);
    setEditRecipeFats(formState.fats);
    setEditRecipeInstructions(recipe.instructions || "");

const nextActiveSections = [];

if (recipe.image) nextActiveSections.push("photo");
if (recipe.description) nextActiveSections.push("description");
if (recipe.time) nextActiveSections.push("time");
if (recipe.servings) nextActiveSections.push("servings");
if (recipe.tag) nextActiveSections.push("tag");
if (recipe.instructions) nextActiveSections.push("instructions");

setActiveEditRecipeSections(nextActiveSections);
  }

  const isAddRecipeValid =
  newRecipeName.trim() &&
  newRecipeCategory &&
  newRecipeIngredients.length > 0 &&
  newRecipeCalories.trim() &&
  newRecipeProtein.trim() &&
  newRecipeCarbs.trim() &&
  newRecipeFats.trim();


  const isNewRecipeNameFilled = !!newRecipeName.trim();
  const isNewRecipeCategoryFilled = !!newRecipeCategory;
  const isNewRecipeIngredientsFilled = newRecipeIngredients.length > 0;
  const isNewRecipeCaloriesFilled = !!newRecipeCalories.trim();
  const isNewRecipeProteinFilled = !!newRecipeProtein.trim();
  const isNewRecipeCarbsFilled = !!newRecipeCarbs.trim();
  const isNewRecipeFatsFilled = !!newRecipeFats.trim();


  const isEditRecipeValid =
  editRecipeName.trim() &&
  editRecipeCategory &&
  editRecipeIngredients.length > 0 &&
  editRecipeCalories.trim() &&
  editRecipeProtein.trim() &&
  editRecipeCarbs.trim() &&
  editRecipeFats.trim();


  const isEditRecipeNameFilled = !!editRecipeName.trim();
  const isEditRecipeCategoryFilled = !!editRecipeCategory;
  const isEditRecipeIngredientsFilled = editRecipeIngredients.length > 0;
  const isEditRecipeCaloriesFilled = !!editRecipeCalories.trim();
  const isEditRecipeProteinFilled = !!editRecipeProtein.trim();
  const isEditRecipeCarbsFilled = !!editRecipeCarbs.trim();
  const isEditRecipeFatsFilled = !!editRecipeFats.trim();


  return {
    editingRecipeName,
    setEditingRecipeName,
    editRecipeImage,
    setEditRecipeImage,

    newRecipeName,
    setNewRecipeName,
    newRecipeImage,
    setNewRecipeImage,   
    newRecipeDescription,
    setNewRecipeDescription,
    newRecipeTime,
    setNewRecipeTime,
    newRecipeCalories,
    setNewRecipeCalories,
    newRecipeServings,
    setNewRecipeServings,
    newRecipeIngredients,
    setNewRecipeIngredients,
    newRecipeCategory,
    setNewRecipeCategory,
    newRecipeTag,
    setNewRecipeTag,
    newRecipeProtein,
    setNewRecipeProtein,
    newRecipeCarbs,
    setNewRecipeCarbs,
    newRecipeFats,
    setNewRecipeFats,
    newRecipeInstructions,
    setNewRecipeInstructions,
    activeNewRecipeSections,
    setActiveNewRecipeSections,


    editRecipeName,
    setEditRecipeName,
    editRecipeDescription,
    setEditRecipeDescription,
    editRecipeTime,
    setEditRecipeTime,
    editRecipeCalories,
    setEditRecipeCalories,
    editRecipeServings,
    setEditRecipeServings,
    editRecipeIngredients,
    setEditRecipeIngredients,
    editRecipeCategory,
    setEditRecipeCategory,
    editRecipeTag,
    setEditRecipeTag,
    editRecipeProtein,
    setEditRecipeProtein,
    editRecipeCarbs,
    setEditRecipeCarbs,
    editRecipeFats,
    setEditRecipeFats,
    editRecipeInstructions,
    setEditRecipeInstructions,
    activeEditRecipeSections,
    setActiveEditRecipeSections,


    addRecipeWarning,
    setAddRecipeWarning,
    hasTriedToSaveAddRecipe,
    setHasTriedToSaveAddRecipe,

    editRecipeWarning,
    setEditRecipeWarning,
    hasTriedToSaveEditRecipe,
    setHasTriedToSaveEditRecipe,

    clearAddRecipeForm,
    cancelEditingRecipe,
    startEditingRecipe,

    isAddRecipeValid,
    isNewRecipeNameFilled,
    isNewRecipeCategoryFilled,
    isNewRecipeIngredientsFilled,
    isNewRecipeCaloriesFilled,
    isNewRecipeProteinFilled,
    isNewRecipeCarbsFilled,
    isNewRecipeFatsFilled,


    isEditRecipeValid,
    isEditRecipeNameFilled,
    isEditRecipeCategoryFilled,
    isEditRecipeIngredientsFilled,
    isEditRecipeCaloriesFilled,
    isEditRecipeProteinFilled,
    isEditRecipeCarbsFilled,
    isEditRecipeFatsFilled
  };
}